import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-price-change-dailog",
  templateUrl: "./price-change-dailog.component.html",
  styleUrls: ["./price-change-dailog.component.css"],
})
export class PriceChangeDailogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<PriceChangeDailogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(){}

  onConfirm(): void {
    this.dialogRef.close(true); // User clicks "Yes"
  }

  onCancel(): void {
    this.dialogRef.close(false); // User clicks "No"
  }
}
